import Axios from "@/plugins/Axios";

export class AnosService {
  async syncAll() {
    if (this.syncAll.anos) return this.syncAll.anos;
    const response = await Axios().get("anos");
    const anos = response.data;
    this.syncAll.anos = anos;
    return anos;
  }

  async monthsAll() {
    const response = await Axios().get("meses");
    const anos = response.data;
    return anos;
  }

  async meses() {
    const response = await Axios().get("meses");
    const meses = response.data;
    return meses;
  }
}
export default new AnosService();
